import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react'
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'

import cn from '@components/utils/cn'

const Circle = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="7" />
  </svg>
)

const RadioGroup = ({
  className,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root> & {
  ref?: Ref<ComponentRef<typeof RadioGroupPrimitive.Root>>
}) => {
  return <RadioGroupPrimitive.Root className={cn('tw:grid tw:gap-2', className)} {...props} ref={ref} />
}

const RadioGroupItem = ({
  className,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & {
  ref?: Ref<ComponentRef<typeof RadioGroupPrimitive.Item>>
}) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        'tw:aspect-square tw:h-4 tw:w-4 tw:rounded-full tw:border tw:border-primary-500 tw:text-primary-500 tw:shadow tw:focus:outline-hidden tw:focus-visible:ring-1 tw:focus-visible:ring-primary-500 tw:disabled:cursor-not-allowed tw:disabled:opacity-50',
        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="tw:flex tw:items-center tw:justify-center">
        <Circle className="tw:h-3.5 tw:w-3.5 tw:fill-primary-500" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
}

export { RadioGroup, RadioGroupItem }
